import { pick } from 'ramda';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { getScript, getStylesheet } from 'js/utils/scripts.util';

import { useIsWidgetsEnabled } from './useIsWidgetsEnabled';

export const useLoadWidgets = () => {
    const { chatJsUrl, chatCssUrl } = useAppSelector(pick(['chatJsUrl', 'chatCssUrl']));
    const [isLoaded, setIsLoaded] = useState(Boolean(window.Communication));
    const { enableChat, enableInbox } = useIsWidgetsEnabled();

    useEffect(() => {
        if (!enableChat && !enableInbox || window.Communication) {
            return;
        }

        Promise.all([
            getScript(chatJsUrl),
            getStylesheet(chatCssUrl)
        ]).then(() => setIsLoaded(true));
    }, [enableChat, enableInbox, chatJsUrl, chatCssUrl]);

    return isLoaded;
};
